import axiosInstance from "../helpers/axiosInstance";

export const getstaffExecutiveApi = async (pageNo, filterData = {}) => {
    let url;

    if (Object.keys(filterData).length > 0) {
        const fn = filterData.firstName ?? "";
        const userId = filterData.userId ?? "";
        const fd = filterData.fromDate ?? "";
        const td = filterData.toDate ?? "";
        url = `staff/reports/salesExecutives?firstName=${fn}&userId=${userId}&fromDate=${fd}&toDate=${td}&page=${pageNo}`;
    } else {
        url = `staff/reports/salesExecutives?page=${pageNo}`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
};

export const getSingleExecutiveApi = async (id, item) => {
    const url = `staff/quotations?salesExecutiveId=${id}&${item}`;
    const response = await axiosInstance.get(url);
    return response.data;
};
